module.exports = __webpack_public_path__ + "static/media/03.f67dd6f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/thailand-two/03.jpg
// module id = 540
// module chunks = 0